import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '@/modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import EvaluationDetails from '../../evaluacion-desempeño-academico/domain/entities/EvaluationDetails'

class DesempeñoInstitucional {
  constructor(id = null, detalles = new EvaluationDetails(), reactivos = []) {
    this.id = id
    this.tipo = ACADEMIC_PERFORMANCE_EVALUATION_TYPES.INSTITUTIONAL_PERFORMANCE
    this.detalle = detalles
    this.reactivos = reactivos
  }

  static fromDto(desempeñoInstitucionalDto) {
    const desempeñoInstitucional = new DesempeñoInstitucional(
      desempeñoInstitucionalDto.id,
      {
        status: desempeñoInstitucionalDto.fk_idCatEstatusEvaluacion,
        idMunicipio: desempeñoInstitucionalDto.fk_idCatMunicipio,
        municipio: desempeñoInstitucionalDto.CatMunicipio,
        idEvaluado: desempeñoInstitucionalDto.fk_idPersonal,
        evaluado: { ...desempeñoInstitucionalDto.Personal },
        idEvaluador: desempeñoInstitucionalDto.fk_idPersonalEvaluador,
        evaluador: { ...desempeñoInstitucionalDto.PersonalEvaluador },
        fechaAplicacion: desempeñoInstitucionalDto.fechaAplicacion,
        fechaFin: desempeñoInstitucionalDto.fechaFin,
        fechaInicial: desempeñoInstitucionalDto.fechaInicial,
        idResultado: desempeñoInstitucionalDto.fk_idResultado,
        institucionSeguridadAspirada: desempeñoInstitucionalDto.institucionSeguridadAspira,
        puestoAspirado: desempeñoInstitucionalDto.aspiranteAlPuesto,
        observaciones: desempeñoInstitucionalDto.observaciones,
      },
      desempeñoInstitucionalDto.frecuenciasMedicion.map((item) => ({
        id: item.id,
        idFrecuencia: item.fk_idCatFrecuencia,
        idReactivo: item.fk_idReactivoEvaluacion,
        estatus: true,
      }))
    )

    return { ...desempeñoInstitucional }
  }
}

export default DesempeñoInstitucional
